import { gestureBox } from "../lib/display/gesture.js";
import "./ComposeOverlay.css";

const HANDLES = [
  { mode: "nw", cls: "compose-overlay__handle--nw" },
  { mode: "ne", cls: "compose-overlay__handle--ne" },
  { mode: "sw", cls: "compose-overlay__handle--sw" },
  { mode: "se", cls: "compose-overlay__handle--se" },
  { mode: "n", cls: "compose-overlay__handle--n" },
  { mode: "s", cls: "compose-overlay__handle--s" },
  { mode: "w", cls: "compose-overlay__handle--w" },
  { mode: "e", cls: "compose-overlay__handle--e" },
];

function layerName(layer) {
  return layer.name ?? layer.role ?? layer.type;
}

export default function ComposeOverlay({
  sizeId,
  scale,
  layers,
  selectedLayerId,
  editable,
  onSelectLayer,
  onSetLayerBox,
}) {
  const startGesture = (e, layer, box, mode) => {
    e.preventDefault();
    e.stopPropagation();
    onSelectLayer(layer.id);
    if (!editable) return;
    const startX = e.clientX;
    const startY = e.clientY;
    let raf = 0;
    let pending = null;
    const commit = () => {
      raf = 0;
      if (pending) onSetLayerBox(layer.id, sizeId, pending);
    };
    const onMove = (ev) => {
      const dx = (ev.clientX - startX) / scale;
      const dy = (ev.clientY - startY) / scale;
      pending = gestureBox(mode, box, dx, dy);
      if (!raf) raf = requestAnimationFrame(commit);
    };
    const onUp = () => {
      window.removeEventListener("pointermove", onMove);
      window.removeEventListener("pointerup", onUp);
      if (raf) cancelAnimationFrame(raf);
      if (pending) onSetLayerBox(layer.id, sizeId, pending);
    };
    window.addEventListener("pointermove", onMove);
    window.addEventListener("pointerup", onUp);
  };

  return (
    <div className="compose-overlay">
      {layers.map((layer) => {
        const b = layer.boxes[sizeId];
        if (!b || b.hidden) return null;
        const isSel = layer.id === selectedLayerId;
        return (
          <div
            key={layer.id}
            role="button"
            tabIndex={-1}
            aria-label={`${layerName(layer)} on ${sizeId}`}
            onPointerDown={(e) => startGesture(e, layer, b, "move")}
            onClick={(e) => e.stopPropagation()}
            className={`compose-overlay__box${isSel ? " compose-overlay__box--selected" : ""}`}
            style={{
              left: b.x * scale,
              top: b.y * scale,
              width: b.w * scale,
              height: b.h * scale,
            }}
          >
            {isSel ? (
              <>
                <span className="compose-overlay__label">{layerName(layer)}</span>
                {editable
                  ? HANDLES.map((h) => (
                      <span
                        key={h.mode}
                        onPointerDown={(e) => startGesture(e, layer, b, h.mode)}
                        className={`compose-overlay__handle ${h.cls}`}
                      />
                    ))
                  : null}
              </>
            ) : null}
          </div>
        );
      })}
    </div>
  );
}